import axios from 'axios'

export default class {
  _documentsPendingUrl
  constructor() {
    this._documentsPendingUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_STATISTICS_PENDING}`
  }

  getTotalDocumentsPending() {
    return axios.get(this._documentsPendingUrl)
  }
}
